var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighCorelationOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09961 1.90039V20.1004",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 20.0996H1.09961",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.5L17.5 3.5",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6.55228 8 7 7.55228 7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7C5 7.55228 5.44772 8 6 8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5C6.27614 7.5 6.5 7.27614 6.5 7C6.5 6.72386 6.27614 6.5 6 6.5C5.72386 6.5 5.5 6.72386 5.5 7C5.5 7.27614 5.72386 7.5 6 7.5Z",
    stroke: "#AECDFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z",
    stroke: "#AECDFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C9.55228 4 10 3.55228 10 3C10 2.44772 9.55228 2 9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5C9.27614 3.5 9.5 3.27614 9.5 3C9.5 2.72386 9.27614 2.5 9 2.5C8.72386 2.5 8.5 2.72386 8.5 3C8.5 3.27614 8.72386 3.5 9 3.5Z",
    stroke: "#AECDFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C6.27614 12.5 6.5 12.2761 6.5 12C6.5 11.7239 6.27614 11.5 6 11.5C5.72386 11.5 5.5 11.7239 5.5 12C5.5 12.2761 5.72386 12.5 6 12.5Z",
    stroke: "#AECDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11C12.4477 11 12 11.4477 12 12C12 12.5523 12.4477 13 13 13Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.5C13.2761 12.5 13.5 12.2761 13.5 12C13.5 11.7239 13.2761 11.5 13 11.5C12.7239 11.5 12.5 11.7239 12.5 12C12.5 12.2761 12.7239 12.5 13 12.5Z",
    stroke: "#AECDFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17C10.5523 17 11 16.5523 11 16C11 15.4477 10.5523 15 10 15C9.44772 15 9 15.4477 9 16C9 16.5523 9.44772 17 10 17Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5C10.2761 16.5 10.5 16.2761 10.5 16C10.5 15.7239 10.2761 15.5 10 15.5C9.72386 15.5 9.5 15.7239 9.5 16C9.5 16.2761 9.72386 16.5 10 16.5Z",
    stroke: "#AECDFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5C15.2761 17.5 15.5 17.2761 15.5 17C15.5 16.7239 15.2761 16.5 15 16.5C14.7239 16.5 14.5 16.7239 14.5 17C14.5 17.2761 14.7239 17.5 15 17.5Z",
    stroke: "#AECDFC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8C16.4477 8 16 8.44772 16 9C16 9.55228 16.4477 10 17 10Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.5C17.2761 9.5 17.5 9.27614 17.5 9C17.5 8.72386 17.2761 8.5 17 8.5C16.7239 8.5 16.5 8.72386 16.5 9C16.5 9.27614 16.7239 9.5 17 9.5Z",
    stroke: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighCorelationOperationIcon);
export default __webpack_public_path__ + "static/media/HighCorelationOperationIcon.f4aff81e5ad4214d2327488be4652ac6.svg";
export { ForwardRef as ReactComponent };